<template>
<div>
  <div class="container">
    <div class="handle-box">
      <el-select v-model="query.firm_id" clearable placeholder="物流公司" class="handle-input mr10">
        <el-option
            v-for="item in firmData"
            :key="item.value"
            :label="item.label"
            :value="item.value"
        >
        </el-option>
      </el-select>
      <el-input v-model="query.no" placeholder="物流单号" class="handle-input mr10"></el-input>
      <el-input v-model="query.send_name" placeholder="寄件人" class="handle-input mr10"></el-input>
      <el-input v-model="query.send_phone" placeholder="寄件人手机号" class="handle-input mr10"></el-input>
      <el-input v-model="query.receive_name" placeholder="收件人" class="handle-input mr10"></el-input>
      <el-input v-model="query.receive_phone" placeholder="收件人手机号" class="handle-input mr10"></el-input>
      <el-date-picker
          v-model="value"
          type="datetimerange"
          value-format="YYYY-MM-DD HH:mm:ss"
          format="YYYY-MM-DD HH:mm:ss"
          align="right"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :default-time="['0000-00-00 00:00:00','3000-00-00 23:59:59']"
          style="margin-right: 10px;"
      >
      </el-date-picker>
      <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="handleAdd">添加</el-button>
    </div>
    <el-table
        :data="tableData"
        border
        class="table"
        ref="multipleTable"
        header-cell-class-name="table-header"
    >
      <el-table-column prop="id" label="ID" width="75" align="center"></el-table-column>
      <el-table-column prop="no" label="物流单号" width="180"  align="center"></el-table-column>
      <el-table-column prop="firm_id" label="物流公司"  align="center" >
        <template #default="scope">
          {{firmMap.get(scope.row.firm_id)}}
        </template>
      </el-table-column>

      <el-table-column prop="money" label="物流金额"  align="right">
        <template #default="scope">
          {{(scope.row.money/100).toFixed(2)}}
        </template>
      </el-table-column>
      <el-table-column prop="order_no" label="订单编号" width="130" align="center"></el-table-column>
      <el-table-column prop="send_name" label="寄件人"  align="center"></el-table-column>
<!--      <el-table-column prop="send_phone" label="寄件人手机号" width="110" align="center"></el-table-column>-->
      <el-table-column prop="receive_name" label="收件人"  align="center"></el-table-column>
      <el-table-column prop="receive_phone" label="收件人手机号" width="110"  align="center"></el-table-column>
      <el-table-column prop="c_at" :formatter="dateFormatHMS" label="创建时间" header-align="center"
                       width="170"></el-table-column>
<!--      <el-table-column prop="receive_address" label="收件人地址"  align="center"></el-table-column>-->
      <el-table-column label="操作" width="150" header-align="center">
        <template #default="scope">
          <el-button
              type="text"
              icon="el-icon-edit"
              @click="handleEdit(scope.row)"
          >编辑
          </el-button>
          <el-button
              type="text"
              icon="el-icon-delete"
              class="red"
              @click="handleDelete(scope.row)"
          >删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
          :current-page="query.page"
          :page-sizes="[10,20, 50, 100, 200]"
          :page-size="10"
          layout="total,sizes, prev, pager, next"
          :total="pageTotal">
      </el-pagination>
    </div>
    <el-dialog
        v-model="expressVisible"
        :close-on-click-modal="false"
        @close="close"
        :title="[code ?'编辑':'添加']+'物流'"
        width="50%">
      <el-form ref="form" :model="form" label-width="180px" :rules="phonerules">
      <el-form-item label="订单编号:" v-if="form.order_id">
        {{form.order_no}}
      </el-form-item>
        <el-form-item prop="firm_id" label="物流公司：">
          <el-select
              v-model.number="form.firm_id"
              class="w200"
              clearable>
            <el-option
                v-for="item in firmData"
                :key="item.value"
                :label="item.label"
                :value="Number(item.value)"
            ></el-option>
          </el-select>
        </el-form-item>
      <el-form-item label="物流金额:" >
        <el-input v-model="form.money" class="w200"></el-input> 元
      </el-form-item>
      <el-form-item label="物流单号:"  prop="no">
        <el-input v-model="form.no" class="w300"></el-input>
      </el-form-item>
      <el-form-item label="寄件人:"  prop="send_name">
        <el-input v-model="form.send_name" class="w150"></el-input>
      </el-form-item>
      <el-form-item label="寄件人手机号:" prop="send_phone">
        <el-input v-model="form.send_phone"  class="w200"></el-input>
      </el-form-item>
      <el-form-item label="收件人:" prop="receive_name">
        <el-input v-model="form.receive_name" class="w150"></el-input>
      </el-form-item>
      <el-form-item label="收件人手机号:" prop="receive_phone">
        <el-input v-model="form.receive_phone" class="w200"></el-input>
      </el-form-item>
      <el-form-item label="收件人地址:" prop="receive_address">
        <el-input type="textarea" v-model="form.receive_address" class="w400" resize="none" rows="5"></el-input>
      </el-form-item>
      </el-form>
      <div style="text-align: right; margin-top: 10px">
        <el-button @click="expressVisible = false">取消</el-button>
        <el-button type="primary" @click="saveExpressSubmit">保存</el-button>
      </div>
    </el-dialog>
  </div>
</div>
</template>

<script>
import {addExpress, deleteExpress, getExpressList, getFirmList} from "@/api/express";
import moment from "moment/moment";

export default {
  name: "ExpressTable",
  data(){
    return{
      query:{
        firm_id:null,
        no:'',
        send_name:'',
        send_phone:'',
        receive_name:'',
        receive_phone:'',
        add_start:null,
        add_end:null,
        add_start_utc: null,
        add_end_utc: null,
        order_no:'',
        page:1,
        page_size:10
      },
      tableData:[],
      firmData:[],
      pageTotal: 0,
      expressVisible:false,
      form:{
        order_id:null,
        firm_id:null,
        money:null,
        no:'',
        send_name:'',
        send_phone:'',
        receive_name: '',
        receive_phone: '',
        receive_address:''
      },
      code:null,
      phonerules: {
        send_phone:[
          { required: true, message: "请输入联系方式", trigger: "blur" },
          { min: 11, max: 11, message: "请输入11位手机号码", trigger: "blur" },
  ],
        receive_phone: [
          { required: true, message: "请输入联系方式", trigger: "blur" },
          { min: 11, max: 11, message: "请输入11位手机号码", trigger: "blur" },
        ],
        no:[{ required: true, message: "请输入物流单号", trigger: "blur" },],
        send_name:[{ required: true, message: "请输入寄件人姓名", trigger: "blur" },],
        receive_name:[{ required: true, message: "请输入收件人姓名", trigger: "blur" },],
        receive_address:[{ required: true, message: "请输入收件人地址", trigger: "blur" },],
      },
      firmMap:new Map(),
      value:[]
    }
  },
  created() {
    this.getData()
    this.getFirmOptions()
  },
  methods:{
    getData(){
      if ((this.value != null)&&(this.value.length != 0)) {
        this.query.add_start = moment(this.value[0]).unix()
        this.query.add_end = moment(this.value[1]).unix()
      } else if(this.value == null){
        this.query.add_start = null
        this.query.add_end = null
      }
      getExpressList(this.query).then(res => {
        this.tableData = res.data
        if (this.query.page === 1) {
          this.pageTotal = res.count
        }
      })
    },

    dateFormatHMS: function (row, column) {
      const date = row[column.property];
      if (date === undefined || date === 0) {
        return "";
      }
      return moment(parseInt(date + "000")).format("YYYY-MM-DD HH:mm:ss")
    },

    // 获取物流公司列表
    getFirmOptions(){
      let that = this
      getFirmList().then(res=>{
        res.forEach(function (item) {
          that.firmMap.set(item.value, item.label)
        })
        this.firmData = res
      }
      )
    },

    // 搜索
    handleSearch(){
      this.query.page = 1
      this.getData()
    },

    handleSizeChange(val){
      this.query.page_size = val
      this.getData()
    },

    // 分页导航
    handlePageChange(val) {
      this.query.page = val
      this.getData()
    },

    //   添加
    handleAdd(){
      this.code = false
      this.form = {}
      this.expressVisible = true
    },


    // 编辑
    handleEdit(row){
      this.code = true
      this.form = JSON.parse(JSON.stringify(row))
      this.form.money = parseFloat(this.form.money / 100).toFixed(2)
      this.expressVisible = true
    },

    // 保存
    saveExpressSubmit(){
      let data = JSON.parse(JSON.stringify(this.form))
      data.money= parseInt(data.money * 100)
      addExpress(this.form.id,data).then(res=>{
            if(res === true){
              this.$message.success('保存成功')
              this.expressVisible = false
              this.getData()
            }
          }
      )
    },

  //   删除
    handleDelete(row){
      // 二次确认删除
      this.$confirm("确定要删除吗？", "删除提示", {
        type: "warning"
      }).then(()=>{
        deleteExpress(row.id).then(res=>{
          if(res){
            this.$message.success('删除成功')
          }
          this.getData()
        })
      })

    }


  }
}
</script>

<style scoped>
.handle-input{
  width: 200px;
  margin-right: 10px;
  margin-bottom: 10px;
}
.el-select{
  margin-right: 10px;
}
.el-button{
  margin-right: 10px;
  margin-bottom: 10px;
}
.handle-box {
  margin-bottom: 10px;
}
.el-form .el-input{
  width: 40%;
}
.red{
  color: red;
}
.el-dialog__body{
  padding-left: 10%;
}
.el-textarea{
  width: 80%;
}
.w200{
  width: 200px !important;
}
.w150{
  width: 150px !important;
}
.w300{
  width: 300px !important;
}
.w400{
  width: 80% !important;
}
</style>